var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoadingMyRole || !_vm.myRoleSettings)?_c('v-container',[_c('fc-role-loading',{attrs:{"is-loading-my-role":_vm.isLoadingMyRole,"my-role-settings":_vm.myRoleSettings}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }